import hotLectures from './hot-lectures.vue'

export default hotLectures
